import $ from 'legacy/jquery';

export const findPronunciationAudio = () => {
  let $pronunciationAudio = $('#touch_screen_availability_widget audio');
  let pronunciationRecorded = $pronunciationAudio.length > 0;
  if (pronunciationRecorded) {
    return $pronunciationAudio[0].src;
  }
};

export const findPronounValues = () => {
  let $pronounInputs = $(
    '#touch_screen_availability_widget input[name^="pronouns_attributes"]'
  );

  if ($pronounInputs.length < 1) {
    return null;
  }

  let result: Record<string, any> = {};
  // @ts-expect-error - TS7006 - Parameter '_index' implicitly has an 'any' type. | TS7006 - Parameter 'input' implicitly has an 'any' type.
  $.each($pronounInputs, (_index, input) => {
    if (input.checked) {
      let value = input.getAttribute('value');
      result[value] = value;
    } else if (input.getAttribute('type') === 'text') {
      result.self_describe_input = input.value;
    }
  });

  return result;
};
